import { useMousePosition } from '../hooks/useMousePosition';
import { CursorStyles, PointerStyles } from '../styles/styles';

const Cursor = () => {
  const { x, y, hoverNav } = useMousePosition();

  return (
    <>
      <CursorStyles
        animate={{
          top: y,
          left: x,
          x: '-50%',
          y: '-50%',
          scale: hoverNav ? 1.8 : 1,
          opacity: hoverNav ? 1 : 0.15,
          border: hoverNav ? '0.1vw solid #131313' : 'none',
          backgroundColor: hoverNav ? '#b1b1b1' : '#d4d4d8',
        }}
        transition={{ ease: 'linear', duration: 0.15 }}
      />
      <PointerStyles
        className={hoverNav ? 'on-focus' : ''}
        style={{
          top: y,
          left: x,
        }}
      />
    </>
  );
};

export default Cursor;
